import { Loader } from '@crossfit/ui'
import { useAffiliateApplication } from 'hooks/useAffiliateAplication'
import React from 'react'
import { trackEvent } from 'services/segment'
import { AffiliateApplicationAttributeActivation } from 'types/Affiliate'
import ApplicationItemCard from './ApplicationItemCard'
import ApplicationWithdrawn from './ApplicationWithdrawn'
import style from './style.module.css'

const APPLICATION_URL = import.meta.env.VITE_AFFILIATE_APPLICATION_URL

export enum ApplicationItemType {
  Application = 'application',
  Location = 'license',
  Insruance = 'insurance',
  Payment = 'payment',
  License = 'license',
  Activation = 'activation',
}

function ApplicationStatus() {
  const applicationStatus = useAffiliateApplication()

  if (applicationStatus == null) {
    return <Loader />
  }

  return (
    <div className={style.wrapper}>
      <div className={style.topInnerWrapper}>
        <p className={style.header}>Application Status</p>
        <button
          onClick={() => {
            trackEvent({
              event: 'View Application Clicked',
              location: 'Affiliate Toolkit',
              text: 'VIEW APPLICATION',
              linkUrl: APPLICATION_URL,
              component: 'Application Status',
            })
            location.href = APPLICATION_URL
          }}
          className={style.applicationButton}
        >
          VIEW APPLICATION
        </button>
      </div>

      <div className={style.divider}></div>

      <div className={style.bottomInnerWrapper}>
        <ApplicationItemCard
          header={'APPLICATION'}
          description={applicationStatus.data.application.description}
          type={ApplicationItemType.Application}
          status={applicationStatus.data.application.status}
          actionText={applicationStatus.data.application.actionText}
          actionUrl={applicationStatus.data.application.actionUrl}
        />
        <ApplicationItemCard
          header={'LOCATION'}
          description={applicationStatus.data.location.rawStatus}
          type={ApplicationItemType.Location}
          status={applicationStatus.data.location.status}
          actionText={applicationStatus.data.location.actionText}
          actionUrl={applicationStatus.data.location.actionUrl}
        />
        <ApplicationItemCard
          header={'INSURANCE'}
          description={applicationStatus.data.insurance.description}
          type={ApplicationItemType.Insruance}
          status={applicationStatus.data.insurance.status}
          actionText={applicationStatus.data.insurance.actionText}
          actionUrl={applicationStatus.data.insurance.actionUrl}
        />
        <ApplicationItemCard
          header={'PAYMENT'}
          description={applicationStatus.data.payment.description}
          type={ApplicationItemType.Payment}
          status={applicationStatus.data.payment.status}
          actionText={applicationStatus.data.payment.actionText}
          actionUrl={applicationStatus.data.payment.actionUrl}
        />
        <ApplicationItemCard
          header={'LICENSE AGREEMENT'}
          description={applicationStatus.data.license.description}
          type={ApplicationItemType.License}
          status={applicationStatus.data.license.status}
          actionText={applicationStatus.data.license.actionText}
          actionUrl={applicationStatus.data.license.actionUrl}
        />
        <ApplicationItemCard
          header={'ACTIVATION'}
          description={applicationStatus.data.activation.description}
          type={ApplicationItemType.Activation}
          status={applicationStatus.data.activation.status}
        />
      </div>
    </div>
  )
}

export default function AffiliateApplication() {
  const applicationStatus = useAffiliateApplication()
  return (
    <div>
      {[
        AffiliateApplicationAttributeActivation.WITHDRAWN.substring(0),
        AffiliateApplicationAttributeActivation.REJECTED.substring(0),
        AffiliateApplicationAttributeActivation.TERMINATED.substring(0),
      ].includes(applicationStatus.data.activation.rawStatus) ? (
        <>
          <ApplicationWithdrawn
            rawStatus={applicationStatus.data.activation.rawStatus}
          />
        </>
      ) : (
        <ApplicationStatus />
      )}
    </div>
  )
}
